import { Timeline, Author } from './itimeline.model';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalNewsletterComponent } from './modal-newsletter/modal-newsletter.component';
import { DashboardService } from '../../shared/services';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  public recent: Recent;
  public statistics: Statistics;
  public timelines: Timeline[] = [];
  public today: Today;

  // transient data
  private data: any[];
  private offset = 0;
  private limit = 10;

  /**
   * Class constructor
   */
  constructor(private router: Router, private route: ActivatedRoute, private modalService: NgbModal,
    private dashboardService: DashboardService) {
    this.data = this.route.snapshot.data['data'];
    console.log(this.data);
    if (!this.data || this.data.length < 4) {
      // TODO something goes wrong. Fetch data separately
    } else {
      this.recent = this.data[0];
      this.statistics = this.data[1];
      this.today = this.data[2];

      // construct timeline object
      if (this.data[3]['pots'] && this.data[3]['pots'].length > 0) {
        const pots = this.data[3]['pots'].map(
          pot => Object.assign(new Timeline(), {
            id: pot['id'],
            name: pot['name'],
            category: 'POT',
            created_at: pot['created_at'],
            author: Object.assign(new Author(), {
              id: pot['author']['id'],
              email: pot['author']['email'],
              firstname: pot['author']['firstname'],
              lastname: pot['author']['lastname'],
              isCompany: pot['author']['isCompany']
            }),
            isToday: moment(pot['created_at']).isSame(new Date(), 'day')
          })
        );

        const donations = this.data[3]['donations'].map(
          donation => Object.assign(new Timeline(), {
            id: donation['id'],
            amount: donation['amount'],
            name: donation['pot']['name'],
            category: 'DON',
            created_at: donation['created_at'],
            author: Object.assign(new Author(), {
              id: donation['author']['id'],
              email: donation['author']['email'],
              firstname: donation['author']['firstname'],
              lastname: donation['author']['lastname'],
              isCompany: donation['author']['isCompany']
            }),
            pot: {
              id: donation['pot']['id'],
              name: donation['pot']['name']
            },
            isToday: moment(donation['created_at']).isSame(new Date(), 'day')
          })
        );

        const timelineOrdered = pots.concat(donations);
        this.timelines = timelineOrdered.sort(this.compareTimelineByDate);
      }
    }
  }

  ngOnInit() { 
  }

  refresh(section: string) {
    console.log('refreshing ' + section);
  }

  onClickNewLetter() {
    this.modalService.open(ModalNewsletterComponent, { size: 'lg' });
  }

  onLoadMore() {
    this.dashboardService.timeline(this.offset + 1, this.limit).subscribe(
      data => {
        const pots: any[] = data['pots'].map(
          pot => Object.assign(new Timeline(), {
            id: pot['id'],
            name: pot['name'],
            category: 'POT',
            created_at: pot['created_at'],
            author: Object.assign(new Author(), {
              id: pot['author']['id'],
              email: pot['author']['email'],
              firstname: pot['author']['firstname'],
              lastname: pot['author']['lastname'],
              isCompany: pot['author']['isCompany']
            }),
            isToday: moment(pot['created_at']).isSame(new Date(), 'day')
          })
        );

        const donations = data['donations'].map(
          donation => Object.assign(new Timeline(), {
            id: donation['id'],
            amount: donation['amount'],
            name: donation['pot']['name'],
            category: 'DON',
            created_at: donation['created_at'],
            author: Object.assign(new Author(), {
              id: donation['author']['id'],
              email: donation['author']['email'],
              firstname: donation['author']['firstname'],
              lastname: donation['author']['lastname'],
              isCompany: donation['author']['isCompany']
            }),
            pot: {
              id: donation['pot']['id'],
              name: donation['pot']['name']
            },
            isToday: moment(donation['created_at']).isSame(new Date(), 'day')
          })
        );

        const timelineNotOrdered = pots.concat(donations);
        timelineNotOrdered.forEach((element: Timeline) => {
          if (this.timelines.filter((timeline: Timeline) => element.id === timeline.id).length === 0) {
            this.timelines.push(element);
          }
        });

        this.timelines = this.timelines.sort(this.compareTimelineByDate);
      });
  }


  private compareTimelineByDate(a: Timeline, b: Timeline) {
    return moment(b.created_at).isAfter(a.created_at) ? 1 : -1;
  }
}

class Recent {
  count_donations: number;
  count_pots: number;
  count_users_new: number;
}

class Statistics {
  invitation: number;
  subscribers: number;
}

class Today {
  amount_donations: number;
  amount_gift_gandee_private: number;
  amount_gift_gandee_company: number;
  amount_service_fee: number;
}


